var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"u-hidden lg:u-block u-ml-auto u-h-6"},_vm._l((_setup.modes),function(mode,index){return _c('a',{key:mode.id,staticClass:"u-text-small u-no-underline u-pb-1 hover:u-border-b-1",class:[{'u-border-b': mode.isSelected,
                 'u-mr-5': index < _setup.modes.length - 1}],attrs:{"href":mode.frontpageUrl},domProps:{"innerHTML":_vm._s(mode.display)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }